import { render, staticRenderFns } from "./download-gd-dlysjg-locate-history-modal.vue?vue&type=template&id=0cfec5d4"
import script from "./download-gd-dlysjg-locate-history-modal.vue?vue&type=script&lang=js"
export * from "./download-gd-dlysjg-locate-history-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports